import React, {useState} from "react";

function TextInput({ additionalClassName, hasLabel, labelText, hasLeftIcon, leftIconName, hasRightIcon, onKeyPress, onClick, value, onChange, placeHolderText, hasErrorText, errorText, propsRef }) {

  const [inputFocus, setInputFocus] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const handleUserInput = (e) => {
    setInputValue(e.target.value);
  }

  const clearUserInput = () => {
    setInputValue("");
  }

  return (
    <div className={`text-input-wrap ${additionalClassName}`}>
      {
        hasLabel &&
        <label className="text-input-label">{labelText}</label>
      }
      <div className={`text-input-box ${inputFocus ? "focus" : ""} ${hasErrorText ? "error" : ""}`}>
        {
          hasLeftIcon &&
          <i className={`left-icon mdi mdi-${leftIconName}`}/>
        }
        <input
          type="text"
          value={value}
          onChange={onChange}
          onKeyPress={onKeyPress}
          placeholder={placeHolderText}
          ref={propsRef}
          onFocus={() => setInputFocus(true)}
          onBlur={() => setInputFocus(false)}/>
        {
          hasRightIcon &&
          <i className={`right-icon mdi mdi-close-circle`} onClick={onClick}/>
        }
      </div>
      {
        hasErrorText &&
        <span className="error-text">{errorText}</span>
      }
    </div>
  );
}

export default TextInput;
